import React from 'react';
import { CreateButton, DeleteRelationshipModal, ModalContainerDiv, RelatedEntityCard, RelationContainer } from './styles';
import { useState } from 'react';
import { Button, Icon, Select, message } from 'antd';
import { useEffect } from 'react';
import { ENTITY_RELATION_VARIABLES } from './translationValues';
import { addVariablerelations, deleteVariablerelations, getVariablerelations } from '../../utils/services/variablesAPI';
import { dummyCallback } from '../../utils/complexDocumentConstants';

const AddRelationships = (props) => {
  const { t, sourceCategoryId, currentCategoryName, allCategories } = props;
  const { Option } = Select;
  const [showRelationModal, setShowRelationModal] = useState(false);
  const [relationsshipType, setRelationshipType] = useState('onetoone');
  const [selectedCategoryId, setSelectedCategoryId] = useState(undefined);
  const [isAddingRelation, setIsAddingRelation] = useState(false);
  const [relationsList, setRelationsList] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [relationToDelete, setRelationToDelete] = useState(null);

  useEffect(() => {
    setFilteredCategories(
      allCategories.filter(
        category => category.id!==sourceCategoryId && !relationsList.some(relation => category.id===relation.targetVariableCategoryId)
      )
    );
  },[relationsList]);

  useEffect(() => {
    fetchData();
  }, [sourceCategoryId]);

  const fetchData = async () => {
    try {
      const result = await getVariablerelations({ id: sourceCategoryId });
      if (result && (!result.errors || result.errors.length === 0)) {
        const fetchedRelations = result.data || [];
        const oneToMany = [];
        const oneToOne = [];

        const formattedRelations = fetchedRelations.map(relation => {
          const updated = {
            ...relation,
            targetId: `element-${relation.id}`,
            targetAnchor: relation.isArray ? 'left' : 'right',
            sourceAnchor: relation.isArray ? 'right' : 'left',
            className: 'arrows arrow-1',
          };

          if (relation.isArray) {
            oneToMany.push(updated);
          } else {
            oneToOne.push(updated);
          }
          return updated;
        });

        setRelationsList(formattedRelations);
        } else {
          message.error(result.errors?.[0] || "Failed to fetch relations");
        }
    } catch (error) {
      console.error("Exception while fetching relations:", error);
      message.error(t(ENTITY_RELATION_VARIABLES.ERROR_ON_FETCH.key,
        ENTITY_RELATION_VARIABLES.ERROR_ON_FETCH.value));
    }
  };


  const handleSaveRelationship = async () => {
    setIsAddingRelation(true);
    try {
      const result = await addVariablerelations({
        sourceVariableCategoryId: sourceCategoryId,
        targetVariableCategoryId: selectedCategoryId,
        isArray: relationsshipType === 'onetomany'
      })
      if (result && (!result.errors || result.errors.length === 0)) {
        message.success(t(ENTITY_RELATION_VARIABLES.ADDED_RELATION.key,
                    ENTITY_RELATION_VARIABLES.ADDED_RELATION.value));
        setSelectedCategoryId(undefined);
        setRelationshipType('onetoone');
        fetchData();
      } else {
        console.error("Error fetching relations:", result.errors);
        message.error(t(ENTITY_RELATION_VARIABLES.RELATION_FETCH_FAILED.key,
          ENTITY_RELATION_VARIABLES.RELATION_FETCH_FAILED.value));
      }
    } catch (error) {
      console.error("Exception while fetching relations:", error);
      message.error(t(ENTITY_RELATION_VARIABLES.ERROR_ON_FETCH.key,
        ENTITY_RELATION_VARIABLES.ERROR_ON_FETCH.value));
    }
    setShowRelationModal(false);
    setIsAddingRelation(false);
  }

  const handleDeleteRelationship = async (relationId) => {
    try {
      const result = await deleteVariablerelations({
        id: relationId
      })
      if (result && (!result.errors || result.errors.length === 0)) {
        message.success(t(ENTITY_RELATION_VARIABLES.DELETED_RELATION.key,
          ENTITY_RELATION_VARIABLES.DELETED_RELATION.value));
        setRelationsList(relationsList.filter(relation=>relation.id !== relationId));
        fetchData();
      } else {
        console.error("Error deleting relation:", result.errors);
        message.error(t(ENTITY_RELATION_VARIABLES.RELATION_DELETE_FAILED.key,
          ENTITY_RELATION_VARIABLES.RELATION_DELETE_FAILED.value));
      }
    } catch (error) {
      console.error("Exception while deleting relations:", error);
      message.error(t(ENTITY_RELATION_VARIABLES.ERROR_ON_DELETE.key,
        ENTITY_RELATION_VARIABLES.ERROR_ON_DELETE.value));
    }
  }
  return (
    <>
      <ModalContainerDiv
        title={<h4>
          {t(ENTITY_RELATION_VARIABLES.ADD_NEW_RELATION_BUTTON.key,
            ENTITY_RELATION_VARIABLES.ADD_NEW_RELATION_BUTTON.value)}
          </h4>}
        centered
        width={500}
        visible={showRelationModal}
        footer={null}
        maskClosable={false}
        className='modal-container'
        styles={{
          header: { paddingBottom: '0px', padding: '16px 34px' },
          body: { paddingTop: '0px' },
        }}
        onCancel={() => setShowRelationModal(false)}
      >
        <div>
          <h4>{currentCategoryName}</h4>
            <Select id="relationshipType" value={relationsshipType} style={{ width: '150px', margin: '20px 0px', display: 'inline-block' }} onChange={e => setRelationshipType(e)}>
              <Option value="onetoone">{t(ENTITY_RELATION_VARIABLES.HAS_ONE_LABEL.key,
                    ENTITY_RELATION_VARIABLES.HAS_ONE_LABEL.value)}</Option>
              <Option value="onetomany">{t(ENTITY_RELATION_VARIABLES.HAS_MANY_LABEL.key,
                    ENTITY_RELATION_VARIABLES.HAS_MANY_LABEL.value)}</Option>
            </Select>
            <Select
              id="relationshipEntity"
              showSearch
              placeholder={t(ENTITY_RELATION_VARIABLES.SELECT_ENTITY_TEXT.key,
                    ENTITY_RELATION_VARIABLES.SELECT_ENTITY_TEXT.value)}
              optionFilterProp="children"
              value={selectedCategoryId ? selectedCategoryId : undefined}
              allowClear={false}
              onChange={value => {
                setSelectedCategoryId(value)
              }}
              style={{ margin: '20px 4px', width: '294px', display: 'inline-block' }}
            >
              {(filteredCategories || []).map(category => (
                  <Option value={category.id} label={category.name}>
                    {category.name}
                  </Option>
              ))}
            </Select>
            <CreateButton type="primary" disabled={selectedCategoryId === undefined} onClick={handleSaveRelationship} style={{ margin: '10px 0 0 238px', height: '46px', width: '210px', justifyContent: 'center' }} loading={isAddingRelation}>
              {isAddingRelation ? t(
                ENTITY_RELATION_VARIABLES.ADDING_LABEL.key,
                ENTITY_RELATION_VARIABLES.ADDING_LABEL.value,
              ) : t(
                ENTITY_RELATION_VARIABLES.ADD_RELATION_BUTTON.key,
                ENTITY_RELATION_VARIABLES.ADD_RELATION_BUTTON.value,
            ) }</CreateButton>
        </div>
      </ModalContainerDiv>
      <div>
      <div style={{ marginTop: '20px'}}>
        <CreateButton
          type="primary"
          onClick={setShowRelationModal}>
            {t(ENTITY_RELATION_VARIABLES.ADD_NEW_RELATION_BUTTON.key,
            ENTITY_RELATION_VARIABLES.ADD_NEW_RELATION_BUTTON.value )}
        </CreateButton>
      </div>
      {relationsList.length>0 && (
        <RelationContainer>
          {relationsList.map(relation => (
            <RelatedEntityCard isArray={relation.isArray}>
              <div className='has-label'>HAS</div>
              <div className='entity-type'>{relation.isArray ? 'N' :'1' }</div>
              <div className='title'>{relation.targetCategoryName}</div>
              <div className='delete-relation'>
                <Icon type="delete" onClick={()=>{setRelationToDelete(relation)}}/>
                <DeleteRelationshipModal
                  className="delete-entity-modal"
                    visible={relationToDelete?.id === relation.id}
                    onOk={() => {
                      handleDeleteRelationship(relation.id);
                      setRelationToDelete(null)}}
                    onCancel={() => setRelationToDelete(null)}
                    bodyStyle={{ padding: '40px' }}
                    maskClosable={false}
                    maskStyle={{ opacity: '0.3' }}
                    footer={[
                      <Button
                        type="danger"
                        onClick={() => {
                      handleDeleteRelationship(relation.id);
                      setRelationToDelete(null)}}
                      >
                          {t(ENTITY_RELATION_VARIABLES.DELETE_RELATION_BUTTON.key,
                          ENTITY_RELATION_VARIABLES.DELETE_RELATION_BUTTON.value )}
                      </Button>
                    ]}
                  >
                    <div style={{ display: 'flex', gap: '20px' }}>
                      <Icon type="delete" style={{ fontSize: '50px', color: 'red' }}/>
                      <div>
                        <h4>
                          {t(ENTITY_RELATION_VARIABLES.CONFIRM_DELETE_TITLE.key,
                        ENTITY_RELATION_VARIABLES.CONFIRM_DELETE_TITLE.value)}</h4>
                        <div>{t(ENTITY_RELATION_VARIABLES.CONFIRM_DELETE_DESCRIPTION.key,
                        ENTITY_RELATION_VARIABLES.CONFIRM_DELETE_DESCRIPTION.value)}</div>
                      </div>
                    </div>
                  </DeleteRelationshipModal>
              </div>
            </RelatedEntityCard>
          ))}
        </RelationContainer>
        )}
      </div>
    </>
  );
};

export default AddRelationships;
